export default __webpack_public_path__ + "static/media/chapter-pc.4a9e1d27.jpg";